import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// types
import { ChannelDeleteType } from '@/api/types/response/ChannelType'

/**
 * @property string apiEnd /api/sales/bid/spec/{bidNumber}/{siteId}/paperwork/channel
 */
export default class ChannelApi extends AbstractApi {
  delete(id: number): Promise<ChannelDeleteType> {
    return httpClient.delete(`${this.apiEnd}/${id}`)
  }
}
